var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm._.trim(_vm.ftieId) === '')?[_vm._v("\n    "+_vm._s(_vm.ftieId)+"\n  ")]:[_c('a',{staticClass:"link",attrs:{"target":"_blank","href":_vm.safeUrl(((_vm.$root.frontEndUrl) + "/dashboard/" + _vm.ftieId))}},[_vm._v(_vm._s(_vm.ftieId))])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721c3cf1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/GtcFTIE.vue
// module id = null
// module chunks = 